import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { change } from 'redux-form';

import { Collapse } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import ChevronUp from 'mdi-material-ui/ChevronUp';
import ChevronDown from 'mdi-material-ui/ChevronDown';

import {
  getActiveMoreFilters,
  getPreparedOffersArray,
} from 'app/store/data/quotationResult';
import { FiltersEnums, FormsEnum, InsuranceEnum } from 'app/shared/enums';
import { SelectBox, SelectBoxMode } from 'app/components/SelectBox';
import LabelWithBrackets from 'app/components/LabelWithBrackets/LabelWithBrackets';
import { selectIsMotorcycle } from 'app/store/data/quotation';
import { getMoreOptionsFilter } from 'app/shared/helpers/filterOptions';

import FilterSection from 'app/components/MoreResultsFilters/FilterSection/FilterSection';

import { FilterSelectBoxProps } from './FilterSelectBoxGroupMobile.interface';
import { useStyles } from './FilterSelectBox.styles';
import { FormTooltip } from 'app/components/FormTooltip';

export default function FilterSelectBox(props: FilterSelectBoxProps) {
  const {
    option,
    isOptionDisabled,
    isOptionLocked,
    numberOffers,
    handleSelectBoxChange,
    input,
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const isMotor = useSelector(selectIsMotorcycle);

  const activeMoreFilters = useSelector(getActiveMoreFilters);
  const offers = useSelector(getPreparedOffersArray);

  const [isExpandedMoreOptions, setIsExpandedMoreOptions] = useState(true);

  const isDisabled = isOptionDisabled && isOptionDisabled(option.value);
  const isLocked = isOptionLocked && isOptionLocked(option.value);
  const countOffers = numberOffers && numberOffers(option.value);
  const moreOptions = getMoreOptionsFilter(isMotor, option.value);

  const isAcAvailable = offers.some((offer) => offer.ac);

  const isAcFilterDisable = option.title === InsuranceEnum.Ac && !isAcAvailable;

  const isSomeOfferContainMoreFilters = offers.some(
    (offer) =>
      offer.carInsuranceOfferViewFilterDto[String(option.value).toLowerCase()]
  );

  const activeMoreFiltersName = activeMoreFilters
    .map((filter) => filter && Object.keys(filter))
    .flat();

  const isCheckedFilterFromSubCategory =
    isSomeOfferContainMoreFilters &&
    moreOptions &&
    moreOptions.sections.some((section) =>
      activeMoreFiltersName.includes(section.name)
    );

  const isChecked =
    (Array.isArray(input.value) && input.value.includes(option.value)) ||
    Boolean(isCheckedFilterFromSubCategory);

  const title =
    countOffers !== undefined ? (
      <LabelWithBrackets label={option.title} textInBrackets={countOffers} />
    ) : (
      option.title
    );

  const titleSelect = isDisabled ? (
    <Tooltip
      title={FiltersEnums.MoreFilterOptionsDisable}
      placement={'top'}
      arrow
      classes={{ tooltip: classes.tooltip }}
    >
      <span>{title}</span>
    </Tooltip>
  ) : isAcFilterDisable ? (
    <div className={classes.titleWrapper}>
      {title}
      <FormTooltip
        content={FiltersEnums.AcFilterNoOffers}
        className={classes.tooltip}
      />
    </div>
  ) : (
    title
  );

  const handleOnChangeMainFilter = (checked: boolean) => {
    if (isCheckedFilterFromSubCategory) {
      const checkedFiltersFromSubCategory =
        moreOptions &&
        moreOptions.sections.filter((section) =>
          activeMoreFiltersName.includes(section.name)
        );

      if (!checkedFiltersFromSubCategory) {
        return;
      }

      checkedFiltersFromSubCategory.forEach((section) => {
        dispatch(change(FormsEnum.OfferFilters, section.name, []));
      });

      if (Array.isArray(input.value) && input.value.includes(option.value)) {
        handleSelectBoxChange(false, option);
      }
    } else {
      handleSelectBoxChange(checked, option);
    }
  };

  return (
    <>
      <div className={classes.filterGroup}>
        <SelectBox
          readonly={isLocked || (isDisabled && !isChecked) || isAcFilterDisable}
          key={option.title + option.value}
          className={classes.item}
          classes={{
            root: classes.selectBoxRoot,
          }}
          title={titleSelect}
          mode={SelectBoxMode.Icon2}
          checked={isChecked}
          onChange={handleOnChangeMainFilter}
        />
        {moreOptions && isSomeOfferContainMoreFilters && (
          <div
            className={classes.adjust}
            onClick={() => setIsExpandedMoreOptions(!isExpandedMoreOptions)}
          >
            {isExpandedMoreOptions ? <ChevronUp /> : <ChevronDown />}
          </div>
        )}
      </div>
      <Collapse in={isExpandedMoreOptions}>
        {moreOptions && isSomeOfferContainMoreFilters && (
          <FilterSection filterSectionOptions={moreOptions} />
        )}
      </Collapse>
    </>
  );
}
